(function () {
  'use strict';

  function init(container) {
    var trigger = container.querySelector('#trigger-open');
    var overlay = container.querySelector('#teaser-overlay');

    function open() {
      if (overlay) overlay.classList.add('overlay-open');
    }

    if (trigger) trigger.addEventListener('click', open);

    container._teaserPageHandlers = { trigger: trigger, open: open };
  }

  function unload(container) {
    var handlers = container._teaserPageHandlers;
    if (!handlers) return;

    if (handlers.trigger) handlers.trigger.removeEventListener('click', handlers.open);

    delete container._teaserPageHandlers;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.teaser-main_cel').forEach(function (container) {
      init(container);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.teaser-main_cel');
    if (container) init(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('.teaser-main_cel');
    if (container) unload(container);
  });
})();
